export default "__VITE_ASSET__D7R5nUcB__"